import React from 'react'
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { TbInfoTriangle, TbInfoTriangleFilled } from "react-icons/tb";

const GameBlocked = (props) => {
  const message = props.t('player_block_togel_market');
  return (
    <div className='information-img'>
      <h2>{props.t('information')}</h2>
      <TbInfoTriangle className="info-icon" />
      <p>{message}</p>
    </div>
  )
}

export default withTranslation()(GameBlocked)
